import React, { useMemo } from 'react';
import styled from 'styled-components';
import Box from '@rsos/components/capstone/base/Box';
import Text from '@rsos/components/capstone/base/Text';

export const StyledLocationSummary = styled(Box)`
  border: 1px solid ${({ theme }) => theme.colors.heavyLineOutline};
  border-radius: 5px;
  padding: 15px 13px;
  margin-bottom: 11px;
  min-height: 87.2px; // avoid jumping when loading;
  justify-content: center;
`;

const LocationSummary = ({
  isLoading = false,
  location = {},
  overridden = false,
  coordinates = {},
}) => {
  const {
    location_name: name,
    street_address: unparsed_address,
    street_address_2: extraAddress,
    locality: city,
    region: state,
    postal_code: zip,
  } = location;

  const address = useMemo(() => {
    let parsedAddress = 'No Address Found';
    if (unparsed_address) {
      parsedAddress = extraAddress
        ? `${unparsed_address} ${extraAddress}`
        : unparsed_address;
    } else if (coordinates?.latitude && coordinates?.longitude) {
      parsedAddress = `${parseFloat(coordinates?.latitude).toFixed(
        5,
      )}, ${parseFloat(coordinates?.longitude).toFixed(5)}`;
    }
    return parsedAddress;
  }, [unparsed_address, extraAddress, coordinates]);

  if (isLoading) {
    return (
      <StyledLocationSummary>
        <Text size="small" fontWeight="bold" color="primaryText">
          Loading...
        </Text>
      </StyledLocationSummary>
    );
  }

  let shouldShowAddress = true;
  if (!unparsed_address && name) {
    shouldShowAddress = false;
  }

  return (
    <StyledLocationSummary>
      {name && (
        <Text size="small" fontWeight="bold" color="primaryText">
          {`${name}`.toUpperCase()}
        </Text>
      )}

      {shouldShowAddress && (
        <Text size="small" fontWeight="bold" color="primaryText">
          {address}
        </Text>
      )}

      <Text size="small" color="primaryText">
        {city || state || zip ? (
          <>
            {city}, {state} {zip}
          </>
        ) : null}
      </Text>

      {!unparsed_address && !city && !state && !zip && address ? (
        <Text size="xsmall" color="secondaryText">
          {<>Estimated Location</>}
        </Text>
      ) : (
        (unparsed_address || city || state || zip) && (
          <Text size="xsmall" color="secondaryText">
            {overridden ? <>Reported Location</> : <>Estimated Location</>}
          </Text>
        )
      )}
    </StyledLocationSummary>
  );
};

export default LocationSummary;
